export default __webpack_public_path__ + "static/media/pipeline-manager.af63a0a2.png";